const cartInfoStyle = {
    outer_box: `bg-liveGameBackground w-full h-auto flex flex-col outer_box min-h-[500px]`,
    border: `border-b border-cartBorder pb-2 flex justify-between items-center`,
    subheading: `text-[18px] font-semibold text-left subheading`,
    item_headings: `flex justify-between items-center border-b border-cardBorder pt-6 mt-2 flex-wrap`,
    table_inner: `w-full`,
    table_body: 'block h-full',
    product_heading: `flex-1 text-left text-[18px] font-[600] pb-2`,
    quantity_heading: `flex-1 text-center text-[18px] font-[600] pb-2`,
    empty_heading: `w-[50px]`,
    subtotal_section: `pt-3 w-full flex`,
    subtotal_inner_box: `flex flex-col gap-2 w-full`,
    subtotal_shipping: `flex flex-col items-end gap-4 pb-3 px-[10px] b-bottom`,
    subtotal_shipping_item: `flex justify-between items-center w-full `,
    button_container: 'flex justify-end pt-5 button_container',
    continue_shopping: 'w-full max-w-[215px] text-[17px]',
    proceed_to_pay: 'w-full max-w-[100%] text-[17px] p-[30px]',
    total_amount: 'flex justify-between items-center w-full pb-3 px-[10px]',
    shipping_box: `flex items-center`,
    text: `text-[14px] font-[400]
           md:text-[20px] md:font-[600]
    `,
    total_text: `text-[18px] font-[400]`,
    values_text: `font-[400] text-[18px] `,
    total_value_text: `text-[24px] font-[600] whitespace-nowrap`,
    original_price: `text-primaryHeading font-400 text-[15px] line-through mr-2`,
    checkout_container: `flex flex-col-reverse gap-5 
                         md:flex-row md:justify-between
    `,
    emptyCart: `text-center font-Suisse text-primaryHeading text-[28px] font-[700]`,
    proceed_to_pay_box: `flex justify-center items-center`,
};

const cartItemStyle = {
    item_container: `grid justify-between py-6 gap-[10px] b-bottom item_container`,
    product_container: `flex flex-row items-start`,
    product_info: `flex flex-col gap-3 product_info`,
    zone_and_quantity_container: `flex flex-wrap gap-x-[20px] justify-between cursor-pointer`, 
    zone_container: `flex items-center gap-4`, 
    description_container: `flex flex-col gap-[8px]`,
    token_container: `w-[100px] h-[100px] flex flex-col items-center justify-center bg-themeColor border border-cubeborder rounded-[10px]`,
    token_image: `w-[100%] h-auto max-w-[56px]`,
    item_description: `item_description text-[#fff] block`,
    item_price: `flex justify-end pt-[15px]`,
    quantity_control: `flex items-center `,
    quantity_button: `text-black text-[15px] w-8 h-8 flex items-center justify-center`,
    cancel_icon: `text-center`,
    cancel_button: `p-2 inline-flex items-center justify-center cursor-pointer`,
    quantity_container: `flex-1 flex justify-center items-center`,
    quantity_text: `mx-2`,
};

const tokenDetailsTableStyle = {
    container: `overflow-x-auto overflow-y-hidden bg-themeColor pt-[6px] px-[14px] pb-[15px] rounded-[10px]`,
    table: `w-[100%]`,
    innerTableHead: `font-[500] px-4 py-2 text-left`,
    innerTableBody: `font-[300] px-4 py-2`,
    tableHead: `px-4 py-2 text-left`,
    tableBody: `px-4 py-2`,
    lastItemBorder: `b-bottom`,
    hoverImage: `cursor-pointer max-w-[20px] min-w-[20px] w-full h-auto`,
    hoveredContainer: `py-1 w-max rounded-[6px] z-10`,
    hoverList: `flex justify-between items-center gap-2`,
    button: `w-full flex items-center`,
    border: `border-b border-gray-200 border-opacity-20`,
    deleteIcon: `max-w-[20px] w-full`,
}

export { cartInfoStyle, cartItemStyle, tokenDetailsTableStyle };